export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://node-server-my-song-and-stripe-0da586e89304.herokuapp.com';
export const LOCAL_URL = 'http://localhost:3006';

export const API_ENDPOINTS = {
  teacher: `${API_BASE_URL}/teacher`,
  talk: `${API_BASE_URL}/talk`,
  notify: `${API_BASE_URL}/api/notify`,
} as const;